import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../../../../_metronic/helpers'

type Data = {
  descricao: string
  url: string
  index: number
}

type Props = {
  data: Data[]
  onDelete: (id: number) => void
}

const Table: React.FC<Props> = ({data, onDelete}) => {
  const intl = useIntl()
  return (
    <>
      {data.length > 0 && (
        <table className='table align-middle table-row-dashed fs-6  dataTable no-footer'>
          <thead>
            <tr className='text-center text-muted fw-bolder fs-7 text-uppercase gs-0'>
              <th>{intl.formatMessage({id: 'COMMON.DESCRIPTION'})}</th>
              <th>URL</th>
              <th>{intl.formatMessage({id: 'MENU.ACTIONS'})}</th>
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold'>
            {data.map((item, index) => (
              <tr key={index} className='text-center text-muted fw-bolder fs-7 text-uppercase gs-0'>
                <td>
                  <div className='d-flex text-center justify-content-center'>
                    <div className='d-flex flex-column'>
                      <a
                        href={item.url}
                        className='border border-gray-100 rounded text-white bg-success px-2 py-1'
                        target='_blank'
                        rel='noreferrer'
                      >
                        {item.descricao}
                      </a>
                    </div>
                  </div>
                </td>
                <td>{item.url}</td>
                <td>
                  {item.url && (
                    <a
                      href={item.url?.toString()}
                      title='Abrir'
                      target='_blank'
                      rel='noreferrer'
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm
          bg-hover-light-primary mx-1'
                    >
                      <KTSVG
                        path='/media/icons/duotune/communication/com001.svg'
                        className='svg-icon-1'
                      />
                    </a>
                  )}
                  <button
                    type='button'
                    title='Excluir'
                    className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm
        bg-hover-light-danger mx-1'
                    onClick={() => onDelete(item.index)}
                  >
                    <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-1' />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  )
}

export default Table
